import * as type from "../types";
import {get} from "../../config/Requests";
import { setData } from './../helpers';
import {
    dashboardDistanceRoute,
    dashboardFuelConsuptionRoute,
    dashboardDriveTimeRoute,
    dashboardPrivateTimeRoute,
    dashboardInServiceListRoute,
    dashboardEcoGradeRoute,
    dashboardEcoListRoute,
    dashboardAlertListRoute,
    dashboarTrophyListRoute,
    dashboardFuelEcoRoute
} from './../../config/routes';

const setEcoCars = (dispatch, value) => {
        dispatch({
            type: type.GET_ECO_CARS,
            value: value
        });
};

const setEcoDrivers = (dispatch, value) => {
        dispatch({
            type: type.GET_ECO_DRIVERS,
            value: value
        });
};

const setEcoLists = (dispatch, response) => {
    if(response.data[0].kod === 200){
        setEcoCars(dispatch, response.data[1].auta);
        setEcoDrivers(dispatch, response.data[1].kierowcy);
    }
};

export const getTotalDistance = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardDistanceRoute,
            null,
            response => setData(dispatch, type.GET_DISTANCE, response)
        );
    };
};

export const getTotalFuelUsage = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardFuelConsuptionRoute,
            null,
            response => setData(dispatch, type.GET_FUEL_USAGE, response)
        );
    };
};

export const getEcoRoutesValues = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardFuelEcoRoute,
            null,
            response => setData(dispatch, type.GET_ECO_ROUTES, response)
        );
    };
};


export const getTotalDriveTime = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardDriveTimeRoute,
            null,
            response => setData(dispatch, type.GET_TOTAL_DRIVE_TIME, response)
        );
    };
};

export const getPrivateDriveTime = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardPrivateTimeRoute,
            null,
            response => setData(dispatch, type.GET_PRIVATE_DRIVE_TIME, response)
        );
    };
};

export const getCarsInService = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardInServiceListRoute,
            null,
            response => setData(dispatch, type.GET_CARS_IN_SERVICE, response)
        );
    };
};

export const getEcoGrade = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardEcoGradeRoute,
            null,
            response => setData(dispatch, type.GET_ECO_GRADE, response)
        );
    };
};

export const getEcoGradeList = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardEcoListRoute,
            null,
            response => setEcoLists(dispatch, response)
        );
    };
};

export const getAlertList = () => {
    return dispatch => {
        get(
            dispatch,
            dashboardAlertListRoute,
            null,
            response => setData(dispatch, type.GET_ALERTS, response)
        );
    };
};

export const getTopTrophyList = () => {
    return dispatch => {
        get(
            dispatch,
            dashboarTrophyListRoute,
            null,
            response => setData(dispatch, type.GET_TOP_TROPHY_LIST, response)
        );
    };
};
